//Users
export const Save_User = (data) => ({
  type: "Save_User",
  payload: data,
});
export const Save_Property = (data) => ({
  type: "Save_Property",
  payload: data,
});

export const Select_Property = (data) => ({
  type: "Select_Property",
  payload: data,
});

export const Select_Partner = (data) => ({
  type: "Select_Partner",
  payload: data,
});

export const Save_VendorTypes = (data) => ({
  type: "Save_VendorTypes",
  payload: data,
});

export const Save_Partners = (data) => ({
  type: "Save_Partners",
  payload: data,
});
export const Save_PendingTasks = (pendingTasks) => ({
  type: "Save_Pending_Tasks",
  payload: pendingTasks,
});
export const Save_Locations = (data) => ({
  type: "Save_Locations",
  payload: data,
});
export const Select_Location = (data) => ({
  type: "Select_Location",
  payload: data,
});
export const Save_Owners = (data) => ({
  type: "Save_Owners",
  payload: data,
});
export const Save_Staffs = (data) => ({
  type: "Save_Staffs",
  payload: data,
});
export const save_Brokers = (data) => ({
  type: "Save_Brokers",
  payload: data,
});

// export const Update_Property = (data) => ({
//   type: "Update_Property",
//   payload: data,
// });

export const Update_User = (data) => ({
  type: "Update_User",
  payload: data,
});

export const Save_isStampRequired = (data) => ({
  type: "Save_isStampRequired",
  payload: data,
});

export const Remove_User = () => ({
  type: "Remove_User",
});

//Games
export const Save_Games_Data = (data) => ({
  type: "Save_Games_Data",
  payload: data,
});
